/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Checkinflyermotifahead3Inputs */

const en_checkinflyermotifahead3 = /** @type {(inputs: Checkinflyermotifahead3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ahead with date`)
};

const de_checkinflyermotifahead3 = /** @type {(inputs: Checkinflyermotifahead3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorab mit Datum`)
};

/**
* | output |
* | --- |
* | "Ahead with date" |
*
* @param {Checkinflyermotifahead3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const checkinflyermotifahead3 = /** @type {((inputs?: Checkinflyermotifahead3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkinflyermotifahead3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_checkinflyermotifahead3(inputs)
	return de_checkinflyermotifahead3(inputs)
});
export { checkinflyermotifahead3 as "checkinFlyerMotifAhead" }